module.exports = __webpack_public_path__ + "img/b4.b033ea5a.png";